// extracted by mini-css-extract-plugin
export default {"areYouSure":"qbx9OwOinKgjhMYRogWp","testnetSkip":"yHy29kiknBOAGcJliuLB"};